<template>
  <v-container class="pa-4">
    <v-card outlined elevation="2">
      <v-card-title>
        <v-icon left class="mr-2">mdi-chart-line</v-icon>
        Analytics Data for last 10 days
      </v-card-title>

      <v-card-text>
        <!-- Toggle -->
        <v-btn-toggle v-model="view" mandatory class="mb-4">
          <v-btn value="table" outlined>Table</v-btn>
          <v-btn value="chart" outlined>Chart</v-btn>
        </v-btn-toggle>

        <div v-if ="view === 'chart'" class="chart-toggle">
          <v-btn-toggle v-model="daysToShow" mandatory class="mb-4">
            <v-btn :value="10" outlined>Last 10 Days</v-btn>
            <v-btn :value="15" outlined>Last 15 Days</v-btn>
          </v-btn-toggle>
        </div>


        <!-- Loading & Error -->
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          class="ma-4"
        ></v-progress-circular>

        <v-alert
          v-else-if="error"
          type="error"
          class="mb-4"
          dense
          border="left"
        >
          {{ error }}
        </v-alert>

        <!-- Table View -->
        <v-data-table
          v-else-if="view === 'table'"
          :headers="headers"
          :items="analyticsData"
          :items-per-page="-1"
          class="elevation-1"
          dense
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>📋 Submissions Data</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>

        <!-- Chart View -->
        <AnalyticsChart
          v-else-if="view === 'chart'"
          :analyticsData="filteredAnalytics"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";
import AnalyticsChart from "./components/AnalyticsChart.vue";

const service = new RestResource();

export default {
  components: {
    AnalyticsChart,
  },

  data() {
    return {
      analyticsData: [],
      loading: false,
      error: null,
      view: "table",
      daysToShow: 10,

      headers: [
        { text: "Date", value: "date" },
        { text: "Submissions", value: "submissions" },
        { text: "Unique Users", value: "uniqueUsersCount" },
      ],
    };
  },

  mounted() {
    this.getAnalyticsData();
  },

  computed: {
    filteredAnalytics() {
      // Sort by date
      const sorted = [...this.analyticsData].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      // Slice based on selected days
      return sorted.slice(-this.daysToShow);
    },
  },

  methods: {
    async getAnalyticsData() {
      this.loading = true;
      this.error = null;
      try {
        const data = await service.getAnalyticsData();
        this.analyticsData = data.data;
      } catch (error) {
        this.error = "Failed to load analytics data.";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
